import React, { useState, useEffect, useContext } from 'react';

import { H2 } from '@zooplus/ui-components';

import LocResourcesContext from '../../../../common/contexts/LocResourcesContext';

const ProgressBarSecondPhase = ({}): JSX.Element => {
  const GLOBAL_PREFIX: string = 'loy-bp-shutdown';
  const { onFormatLocale } = useContext(LocResourcesContext);
  const [progress, setProgress] = useState<number>(0);
  const [remainingDays, setRemainingDays] = useState<number>(0);
  const startDate = new Date('2024-04-01');
  const endDate = new Date('2024-04-30');
  const currentDate = new Date();

  const calculateProgress = () => {
    const totalTime = endDate.getTime() - startDate.getTime();
    const elapsedTime = currentDate.getTime() - startDate.getTime();
    const currentProgress = (elapsedTime / totalTime) * 100;
    setProgress(currentProgress);
  };
  const calculateRemainingDays = () => {
    const remainingTime = endDate.getTime() - currentDate.getTime();
    const remainingDays = Math.ceil(remainingTime / (1000 * 60 * 60 * 24));
    setRemainingDays(remainingDays);
  };

  useEffect(() => {
    calculateProgress();
    calculateRemainingDays();
  }, []);

  return (
    <div className={`${GLOBAL_PREFIX}-progress-bar`}>
      <H2 style={{ marginTop: '40px' }}>{onFormatLocale?.('loy.bp.shutdown.progressbar.title')}</H2>
      <div className={`${GLOBAL_PREFIX}-progress-bar__box`}>
        <div className={`${GLOBAL_PREFIX}-progress-bar__chart__text--up`}>
          <div className={`${GLOBAL_PREFIX}-progress-bar__chart__text--up__item`}>
            <div className={`${GLOBAL_PREFIX}-progress-bar__chart__text--title`}>
              {onFormatLocale?.('loy.bp.shutdown.progressbar.start.date')}
            </div>
            <div className={`${GLOBAL_PREFIX}-progress-bar__chart__text--description`}>
              {onFormatLocale?.('loy.bp.shutdown.progressbar.start.date.description')}
            </div>
          </div>
          <div className={`${GLOBAL_PREFIX}-progress-bar__chart__text--up__item`}>
            <div className={`${GLOBAL_PREFIX}-progress-bar__chart__text--title`}>
              {onFormatLocale?.('loy.bp.shutdown.progressbar.end.date')}
            </div>
            <div className={`${GLOBAL_PREFIX}-progress-bar__chart__text--description`}>
              {onFormatLocale?.('loy.bp.shutdown.progressbar.end.date.description')}
            </div>
          </div>
        </div>
        <div className={`${GLOBAL_PREFIX}-progress-bar__chart`}>
          <div style={{ width: `${progress}%`, height: '100%' }}>
            <div className={`${GLOBAL_PREFIX}-progress-bar__chart--progress`}>
              <div className={`${GLOBAL_PREFIX}-progress-bar__chart--border-concave`}></div>
            </div>
          </div>
        </div>
        <div className={`${GLOBAL_PREFIX}-progress-bar__chart__text--bottom`}>
          <div className={`${GLOBAL_PREFIX}-progress-bar__chart__text--bottom__item`}>
            <div className={`${GLOBAL_PREFIX}-progress-bar__chart__text--title`}>
              {onFormatLocale?.('loy.bp.shutdown.progressbar.progress', { 0: remainingDays })}
            </div>
          </div>
        </div>
      </div>
      <p>{onFormatLocale?.('loy.bp.shutdown.progressbar.paragraph-1')}</p>
      <p>{onFormatLocale?.('loy.bp.shutdown.progressbar.paragraph-2')}</p>
    </div>
  );
};

export default ProgressBarSecondPhase;
